import type { BlockedAttribute, BlockListRow } from 'BlockList/types';

/** Wire (snake_case) → domain (camelCase) row transform. Shared by every
 *  blocklist service so consumers see one BlockListRow shape. */
export const transformBlockListRow = (row: BlockedAttribute): BlockListRow => ({
  id: row.id,
  attributeType: row.attribute_type,
  value: row.value,
  reason: row.reason,
  notes: row.notes,
  source: row.source,
  active: row.active,
  createdByType: row.created_by_type,
  createdById: row.created_by_id,
  createdAt: row.created_at,
  updatedAt: row.updated_at,
  deactivatedAt: row.deactivated_at,
  deactivatedByPortalUserId: row.deactivated_by_portal_user_id,
  blockedPolicies: row.blocked_policies.map((bp) => ({
    id: bp.id,
    policyId: bp.policy_id,
    policyNumber: bp.policy_number,
  })),
});
